import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Form, FormGroup, Label, Input, FormText, Button } from 'reactstrap';
import session from '../../../core/session';
import trueLogoText from '../../../assets/img/logo.svg'

import LoadingIndicator from '../../components/loading-indicator';
import { userActions, getCurrentUser } from '../../../core/users';
import { systemCheckActions } from '../../../core/systemCheck/actions';

class LoginForm extends Component {
    constructor(props) {
        super(props);
        const { user } = this.props
        this.state = {
            email: user?.error?.data?.belongs_to_any_account && !user?.error?.data?.belong_to_current_account ? user.email : '',
            password: '',
            errorInputs: null,
            rememberMe: false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getErrorRequest = this.getErrorRequest.bind(this);
    }

    componentDidMount() {
        const user = session.getRememberUser();
        if (user) {
            this.setState({
                email: user.email,
                password: user.password,
                rememberMe: !this.state.rememberMe
            })
        }
    }

    handleSubmit(e) {
        e.preventDefault()
        const { actions } = this.props;
        const { email, password, rememberMe } = this.state;

        if (this.validateForm()) {
            actions.loadUser({
                email,
                password
            });
            rememberMe ?
                session.setRememberUser({ email, password }) :
                session.deleteRememberUser();
            }
    }

    handleInputChange({ target }) {
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;

        this.setState({
            [name]: value
        });
    }

    validateForm = () => {
        const { email, password } = this.state;

        if (email?.length === 0 && password?.length !== 0 ) {
            this.setState({
                errorInputs: {
                    emailError: 'Email is required',
                    passwordError: ''
                }
            })
            return false;
        }
        
        if (password?.length === 0 && email?.length !== 0 ) {
            this.setState({
                errorInputs: {
                    emailError: '',
                    passwordError: 'Password is required'
                }
            })
            return false;
        }
        
        if(email?.length === 0  && password?.length === 0) {
            this.setState({
                errorInputs: {
                    emailError: 'Email is required',
                    passwordError: 'Password is required'
                }
            })
        }
        else {
            this.setState({
                errorInputs: null
            })
            return true;
        }
    }

    getErrorRequest = () => {
        const { user } = this.props
        let error = ""

        if(user?.error?.message) {
            const belong_to_current_account = user.error.data?.belong_to_current_account;
            const belongs_to_any_account = user.error.data?.belongs_to_any_account;
            const invalid_password = user.error.data?.invalid_password;

            switch(user?.error?.message) {
                case "Unauthorized": 
                    if(!belongs_to_any_account) {
                        error = <FormText>
                            This email address does not exist in our system. <br/>
                            Please check your email or create a new account by clicking the button below. <br/>
                            If you experience any issues <Link to="/contact-us"> contact us here. </Link>
                        </FormText>
                    } else if(!belong_to_current_account && !invalid_password) {
                        error = <FormText>
                            This user does not belong to this Account. <br/>
                            <Link to="/account-information-sent"> Please click here </Link> to recieve an email with the correct account information. <br/>
                            If you experience any issues <Link to="/contact-us"> contact us here. </Link>
                        </FormText>
                    } else if(belong_to_current_account && invalid_password) {
                        error = <FormText>
                            The password isn't right. <br/>
                            <Link to="/forgot-password"> Please click here </Link> to recover your password. <br/>
                            If you experience any issues <Link to="/contact-us"> contact us here. </Link>
                        </FormText>
                    } else if(!belong_to_current_account && invalid_password) {
                        error = <FormText>
                            This user does not belong to this Account. <br/>
                            Please verify My True Advance account url or create a new user. <br/>
                            If you experience any issues <Link to="/contact-us"> contact us here. </Link>
                        </FormText>
                    }
                    break;

                case "validation":
                    if(user.error?.data)
                        error = Object.keys(user.error?.data).map((itemError, index) => {
                            return <FormText>{user.error?.data[itemError]}</FormText>
                        })
                    break;

                case "Request failed with status code 429":
                    error = <FormText> Too many attempts, please wait a minute and try again. </FormText>
                    break;

                default: 
                    error = <FormText> An error has occurred, please wait and try again later. </FormText>
                    break;
            }
        }

        return error
    }

    render() {
        const { email, password, errorInputs, rememberMe } = this.state;
        const { user, systemCheck } = this.props;

        return (
            <>
                <div className="content-login mb-auto pb-4">
                    <img src={trueLogoText} alt="True Advance" className='logo mb-4'/>
                    <h3 className="libre-caslon-text-regular mb-3">Get Started</h3>
                    <Form className="form-login">
                        <FormGroup className='mb-3'>
                            <Label htmlFor="inputEmail">Email Address</Label>
                            <Input type="email" onChange={this.handleInputChange} value={email} name="email" id="inputEmail" placeholder='username@mail.com' />
                            {errorInputs && <FormText>{errorInputs.emailError}</FormText>}
                        </FormGroup>
                        <FormGroup className='mb-3'>
                            <Label htmlFor="inputPassword">Password</Label>
                            <Input type="password" onChange={this.handleInputChange} value={password} name="password" id="inputPassword"/>
                            {errorInputs && <FormText>{errorInputs.passwordError}</FormText>}
                            {user?.error?.message && this.getErrorRequest()}
                        </FormGroup>
                        <FormGroup check className="mb-3">
                            <Label check>
                                <Input type="checkbox" name="rememberMe" value={rememberMe} onChange={this.handleInputChange} />{' '}Remember me
                            </Label>
                        </FormGroup>
                        <Button type="submit" onClick={this.handleSubmit} color='green-light' className='py-2 rounded-sm mb-3' block>Sign in to account</Button>
                        <p className="text-center mb-3">
                            <Link to={'/forgot-password'} className="text-reset">Forgot Password?</Link>
                        </p>
                    </Form>
                </div>
                {(systemCheck && systemCheck.allow_register) &&
                    <div className="text-center pt-4">
                        <p className='text-muted'>Don't have an account? Click here to <Link to={'/signup'} className="text-danger font-weight-semibold">Create a New Account</Link>.<br/>By creating an account, you agree to the True Advance Code of Conduct</p>
                    </div>
                }

                {user.isPending && <LoadingIndicator />}
            </>
        )
    }
}

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {

    return {
        checked: state.user.checked,
        user: state.user,
        systemCheck: state.systemCheck && state.systemCheck.data && state.systemCheck.data.data
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(userActions, dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginForm);
